export async function sendResumeByEmail(email) {
    console.log('Sending resume to:', email);
    const res = await fetch("./.netlify/functions/triggerResumeEmail", {
        method: "POST",
        body: JSON.stringify({
            subscriberEmail: email,
            subscriberName: extractName(email),
        }),
    });

    if (!res.ok) {
        throw new Error("Failed to send email");
    }

    return res;
}

export function checkEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

function extractName(email) {
    return email.split('@')[0];
}

export function applyResultStyles(isSuccess, element, message) {
    element.classList.add(isSuccess ? 'success' : 'error');
    setTimeout(() => {
        element.classList.remove('error', 'success');
    }, 2000);
    emptyAndPlaceholder(element, message);
}

export function emptyAndPlaceholder(element, message) {
    element.value = '';
    element.placeholder = message;
}